import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";

function useDeleteConta(invalidateQuery = "/v1/conta") {
  const queryClient = useQueryClient();
  return useMutation(
    `delete/v1/conta`,
    (ids: string[]) =>
      http.delete(`/v1/conta`, {
        data: { ids },
      }),
    {
      retry: false,
      onSuccess: () => {
        if (invalidateQuery) {
          queryClient.invalidateQueries({
            predicate: ({ queryKey }) =>
              typeof queryKey === "string" && queryKey.startsWith(invalidateQuery),
          });
        }
      },
    }
  );
}

export default useDeleteConta;
